angular.module('unica_campaign.campaign_services')

.factory('CampaignListService', function($http, getBaseApiURL) {

	var campaignListService = {};

	campaignListService.list = function (eventId)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/campaign/list/' + eventId,
			data: {}
		}).then(function(result) {

			if ( result ) {
				return result.data.campaigns;
			}

		});
	};

	campaignListService.get = function (campaignId)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/campaign/detail/' + campaignId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return result.data.campaign;
			}

		});

	};

	return campaignListService;

});